
angular.module('v3sWbtPlayerApp').directive('v3sGaptext', function () {
    return {
        restrict: 'E',
        require: '^v3sDocument',
        scope: {
            id: '@',
            v3sTolerance: '@'
        },
        controller: ["$scope", "$element", function ($scope, $element) {
            var gaps = $element.find("v3s-gap");

            this.getTolerance = function () {
                return $scope.v3sTolerance || "100";
            };
            this.getIndex = function (gap) {
                for (var i = 0; i < gaps.length; i++){
                    if (gaps[i] == gap) return i;
                }
                return "";
            };
        }],
        link: function (scope, element, attributes, docCtrl) {
            if (!!scope.id) {
                docCtrl.addElement(element);
            }
        }
}
});

angular.module('v3sWbtPlayerApp').directive('v3sGap', ["$compile", function ($compile) {
    return {
        restrict: 'E',
        require: '^v3sGaptext',
        link: function (scope, element, attributes, gaptextCtrl) {
            var answer = element.text();
            var tolerance = gaptextCtrl.getTolerance();

            var index = gaptextCtrl.getIndex(element[0]);

            element.html('<v3s-input id="GAP' + index + '" v3s-size="' + (answer.length + 1) + '" v3s-tolerance="' + tolerance + '"><v3s-correct>' + answer + '</v3s-correct></v3s-input>');
            $compile(element.children())(scope);
    }
}
}]);
